import axios, { AxiosError } from "axios";
import { IResponse } from "./interactionApi";

export function handleError(error: unknown, mess: string): any {
	console.log(mess, error);
	if (axios.isAxiosError(error)) {
		const serverError = error as AxiosError<unknown>;
		if (serverError && serverError.response) {
			return Promise.reject(serverError.response.data);
		}
	}
	return Promise.reject({ message: `Error: ${mess}` });
}

export function handleResponse<T>(data: IResponse<T>): T {
	if (data.success) return data as unknown as T;
	return { errorMsg: data.message } as unknown as T;
}

export function handleResponseCommission<T>(data: IResponse<T>): T {
	if (data.success) return data as unknown as T;
	return { errorMsg: data.message } as unknown as T;
}


// random n-digit number as string (first digit != 0), crypto-safe, no bias
// export function randomDigits(n: number): string {
//   if (n < 1) throw new Error("n must be >= 1");
//   const getRandomValues =
//     (globalThis as any).crypto?.getRandomValues ??
//     require("crypto").webcrypto.getRandomValues;

//   const pickDigit = (maxExclusive: number, offset = 0) => {
//     // rejection sampling to avoid modulo bias
//     // e.g. for 0..9 -> accept 0..249 then v % 10
//     const limit = Math.floor(256 / maxExclusive) * maxExclusive; // 250 for 10, 252 for 9
//     let v = 256;
//     while (v >= limit) {
//       const a = new Uint8Array(1);
//       getRandomValues(a);
//       v = a[0];
//     }
//     return (v % maxExclusive) + offset; // offset=1 for first digit (1..9)
//   };

//   // first digit: 1..9
//   let out = String(pickDigit(9, 1));
//   // remaining: 0..9
//   for (let i = 1; i < n; i++) out += String(pickDigit(10, 0));
//   return out;
// }